export default __webpack_public_path__ + "static/media/vox-logo.335b0c02.svg";